import { PayloadAction, createSlice, noopReducer } from 'ngrx-slice';

import {
  PageSiteMerchantTypesResponse,
  PageableObject,
  SiteMerchantTypeStatusUpdateRequest,
  SortObject,
} from '@app/api/marketplace/models';
import { paginatorConfiguration } from '@shared/constants/paginator-configuration';
import { PageRequest } from '@shared/interfaces/page-request.interface';
import { PageResponse } from '@shared/interfaces/page-response.interface';

export const initialDataState = {
  totalPages: 0,
  totalElements: 0,
  size: 0,
  content: [],
  number: 0,
  sort: {} as SortObject,
  pageable: {} as PageableObject,
  first: true,
  last: true,
  numberOfElements: 0,
  empty: true,
};

export interface State {
  filter: PageRequest;
  dataLoadError: boolean;
  dataLoading: boolean;
  data: PageResponse<PageSiteMerchantTypesResponse>;
  totalData: number;
  statusSaving: boolean;
  statusSaveError: boolean;
}

export const initialState: State = {
  filter: {
    page: paginatorConfiguration.defaultPageIndex,
    size: paginatorConfiguration.pageSizeOptions[0],
  },
  dataLoadError: false,
  dataLoading: false,
  data: initialDataState,
  totalData: 0,
  statusSaving: false,
  statusSaveError: false,
};

export const {
  actions: MerchantApprovalsActions,
  selectors,
  ...MerchantApprovalsFeature
} = createSlice({
  name: 'merchant-approvals',
  initialState,
  reducers: {
    getMerchantTypeRequests: {
      trigger: (state) => {
        state.dataLoading = true;
      },
      success: (
        state,
        action: PayloadAction<{
          response: PageResponse<PageSiteMerchantTypesResponse>;
        }>
      ) => {
        state.data = action.response;
        state.totalData = action?.response.totalElements ?? 0;
        state.dataLoading = false;
        state.dataLoadError = false;
      },
      failure: (state) => ({
        ...state,
        dataLoading: false,
        dataLoadError: true,
      }),
    },
    updateFilter: {
      trigger: (
        state,
        action: PayloadAction<{
          filter: { page?: number; size?: number; sort?: Array<string> };
        }>
      ) => {
        state.filter = action.filter;
      },
      success: noopReducer(),
    },
    updateMerchantTypeStatus: {
      trigger: (
        state,
        _action: PayloadAction<{ request: SiteMerchantTypeStatusUpdateRequest }>
      ) => {
        state.statusSaving = true;
      },
      success: (state) => {
        state.statusSaving = false;
        state.statusSaveError = false;
      },
      failure: (state) => ({
        ...state,
        statusSaving: false,
        statusSaveError: true,
      }),
    },
    reset: (_) => initialState,
  },
});

export const MerchantApprovalsSelectors = {
  ...selectors,
};
